/* eslint-disable lines-around-comment */
import React from 'react';
// @ts-ignore
import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n/functions';
import { connect } from '../../../base/redux/functions';
import Switch from '../../../base/ui/components/web/Switch';
import AbstractMuteEveryonesVideoDialog, { abstractMapStateToProps } 
// @ts-ignore
from '../AbstractMuteEveryonesVideoDialog';
/**
 * A React Component with the contents for a dialog that asks for confirmation
 * from the user before disabling all remote participants cameras.
 *
 * @augments AbstractMuteEveryonesVideoDialog
 */
class MuteEveryonesVideoDialog extends AbstractMuteEveryonesVideoDialog {
    /**
     * Toggles advanced moderation switch.
     *
     * @returns {void}
     */
    _onToggleModeration() {
        // @ts-ignore
        this.setState(state => {
            return {
                moderationEnabled: !state.moderationEnabled,
                // @ts-ignore
                content: this.props.t(state.moderationEnabled
                    ? 'dialog.muteEveryonesVideoDialog' : 'dialog.muteEveryonesVideoDialogModerationOn')
            };
        });
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement(Dialog, { okKey: 'dialog.muteParticipantsVideoButton', onSubmit: this._onSubmit, 
            // @ts-ignore
            titleString: this.props.title, width: 'small' },
            React.createElement("div", { className: 'mute-dialog' },
                this.state.content,
                this.props.isModerationSupported && this.props.exclude.length === 0 && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'separator-line' }),
                    React.createElement("div", { className: 'control-row' },
                        React.createElement("label", { htmlFor: 'moderation-switch' }, this.props.t('dialog.moderationVideoLabel')),
                        React.createElement(Switch
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            checked: !this.state.moderationEnabled, id: 'moderation-switch', onChange: this._onToggleModeration })))))));
    }
}
// @ts-ignore
export default translate(connect(abstractMapStateToProps)(MuteEveryonesVideoDialog));
